import{ createContext } from 'react'

export const JuecoContext = createContext();
